__turbopack_context__.v({
  "tableContainer": "IndicatorTable-modal-module__-nTuzq__tableContainer",
});
